import { Error } from './Error';

export class ValidationResult {
	public constructor(
		public readonly referencePackageSizeIsMissing: boolean,
		public readonly productErrors: Error[],
		public readonly countryErrors: Error[]
	) {}
}
